import * as React from 'react';
import { CheckboxInline } from '@common/components/checkbox-inline/checkbox-inline';
import { Control } from 'react-redux-form';
import { ContractResaleEmailViewModel } from '@models/Contract';
import { ModalProps } from '@common/components';
import { FormWrapper } from '../../../common/components/form-wrapper/form-wrapper.component';
export interface ContractResaleEmailProperties {
  readonly resaleNotifications: Array<ContractResaleEmailViewModel>;
  readonly resaleEmails: Array<string>;
  readonly id: number;
  readonly addEmail: (email: string) => void;
  readonly removeEmail: (email: string) => void;
  readonly getContractResaleEmailNotifications: (id: number) => void;
  readonly sendResaleEmails: (id: number, emails: Array<string>) => void;
  readonly toggleModal: (modalProps?: ModalProps) => void;
}

export class ContractResaleEmailComponent extends React.Component<ContractResaleEmailProperties> {
  constructor(props: ContractResaleEmailProperties) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    if (this.props.id) {
      this.props.getContractResaleEmailNotifications(this.props.id);
    }
  }

  handleAddNotification = (e: Event) => {
    e.preventDefault();
    e.stopPropagation();

    const input = document.getElementById('emailAddress') as HTMLInputElement;
    const email: string = input.value;

    this.props.addEmail(email);
    input.value = '';
  };

  handleRemoveNotification = (email: string) => {
    this.props.removeEmail(email);
  };
  handleSubmit(form: any) {
    if (this.props.id) {
      this.props.sendResaleEmails(this.props.id, form.resaleNotifications);
      this.props.toggleModal();
    }
  }

  render() {
    return (
      <FormWrapper
        shouldFormReset={true}
        model="contractResaleEmailForm"
        hideNativeErrors={true}
        onSubmit={this.handleSubmit}
      >
        <div className="col-lg-6">
          <h3>Notifications</h3>
          <div className="row mb-10 pb-10">
            <label className="mb-10">Please select the parties you wish to notify of the Contract Resale</label>
            <div className="col-xs-12">
              <div className="row">
                {this.props.resaleNotifications.map((notification, index) => {
                  return (
                    <div className="col-md-4" key={notification.email}>
                      <CheckboxInline>
                        <Control.checkbox model={`.resaleNotifications[${index}]`} value={notification.email} />
                        <label htmlFor="contractResaleEmailForm.notifications">{notification.description}</label>
                      </CheckboxInline>
                    </div>
                  );
                })}
              </div>
              <div className="row bottom-xs mt-10 mb-10">
                <div className="col-md-6">
                  <label>Additional Cancellation Notification Email</label>
                  <input id="emailAddress" type="email" />
                </div>
                <button
                  className="btn btn-secondary"
                  type="button"
                  onClick={(event: any) => this.handleAddNotification(event)}
                >
                  Add
                </button>
                <div className="col-xs-12">
                  <ul>
                    {this.props.resaleEmails.map((email: string) => {
                      return (
                        <li key={email} className="mt-5">
                          <span>{email}</span>
                          &nbsp;
                          <button type="button" onClick={() => this.handleRemoveNotification(email)}>
                            X
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12">
          <div className="row end-xs">
            <button className="btn btn-primary" type="submit">
              Send Emails
            </button>
          </div>
        </div>
      </FormWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/contract/_components/contract-resale-email/contract-resale-email.component.tsx